import React from "react";
import Marquee from "react-fast-marquee";

const MarqueeBand = ({ items, dark = false, speed = 40, className = "" }) => {
    return (
        <div
            data-testid="marquee-band"
            className={`marquee-divider ${dark ? "section-dark" : ""} ${className}`}
        >
            <Marquee speed={speed} gradient={false} pauseOnHover={false}>
                {items.map((t, i) => (
                    <span
                        key={i}
                        className="font-serif italic text-4xl md:text-5xl lg:text-6xl mx-10 opacity-90"
                    >
                        {t}
                        <span className="mx-10 inline-block w-2 h-2 rounded-full align-middle bg-[var(--st-gold)]"></span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default MarqueeBand;
